/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import Ladda from 'ladda';
import Backbone from 'backbone';
import moment from 'moment';

import showModal from '@/util/showModal';
import ConfirmationModalView from '@/views/ConfirmationModalView';
// import showErrorMessage from '@/util/showErrorMessage';

import SendEmailAssetReminder from '../../services/SendEmailAssetReminder';
import ExpiringContractGrid from '../ExpiringContractGrid/ExpiringContractGrid';

import tmplSendRemindersView from './SendRemindersView.hbs';

const SendRemindersView = View.extend({
  template: tmplSendRemindersView,

  ui: {
    fundingReminderBtn: '.send-funding-reminder-button',
    expiringContractReminderBtn: '.send-contract-reminder-button',
    expiredContractsCommandPocsGrid: '#expiredContractsCommandPocsGrid'
  },

  events: {
    'click @ui.fundingReminderBtn': 'onClickSendFundingReminder'
  },

  regions: {
    expiredContractsCommandPocsGrid: '@ui.expiredContractsCommandPocsGrid'
  },

  onRender() {
    this.expiredContractsCommandPocsGrid = new ExpiringContractGrid({
      model: new Backbone.Model({
        expiringContractsDetails: this.model.get('expiringContractsDetails'),
        orderFormTypes: this.model.get('orderFormTypes')
      })
    });
    this.showChildView('expiredContractsCommandPocsGrid', this.expiredContractsCommandPocsGrid);
  },

  async onClickSendFundingReminder(e) {
    e.preventDefault();
    const self = this;
    const message = `An email will be sent to every customer with outstanding funding documents as listed in the current asset inventory. Are you sure you want to send funding renewal notifications?`;
    showModal({
      title: 'Send Funding Renewal Notifications',
      view: new ConfirmationModalView({
        confirmText: 'Yes',
        model: new Backbone.Model({
          message,
          async onConfirm() {
            const spinner = Ladda.create(self.ui.fundingReminderBtn[0]);
            spinner.start();
            await SendEmailAssetReminder();
            self.model.set('manualFundingReminderDateSent', moment().format('MM/DD/YYYY'));
            self.render();
            spinner.stop();
            return Promise.resolve();
          }
        })
      })
    });
  },

  // async onClickSendExpiringContractReminder(e) {
  //   e.preventDefault();

  //   const selectedPocs = this.expiredContractsCommandPocsGrid.viewGrid.getSelectedModels();
  //   if (selectedPocs.length <= 0) {
  //       this.showExpiringContractSelectionError();
  //       return;
  //   }

    //HANDLE THIS CASE: if POC info is missing, show a notification modal listing Contract #s missing POC info
//     const self = this;
//     const message = `An email will be sent to every customer with expiring contracts as listed in the current asset inventory. Are you sure you want to send expiring contract notifications?`;
//     showModal({
//       title: 'Send Expiring Contract Notifications',
//       view: new ConfirmationModalView({
//         confirmText: 'Yes',
//         model: new Backbone.Model({
//           message,
//           async onConfirm() {
//             const spinner = Ladda.create(self.ui.expiringContractReminderBtn[0]);
//             spinner.start();
//             // await SendEmailAssetReminder(); //SendEmailExpiringContractReminder();
//             self.render();
//             spinner.stop();
//             return Promise.resolve();
//           }
//         })
//       })
//     });
// },

//   showExpiringContractSelectionError() {
//     showErrorMessage({
//         errorCode: 'expiringContractSelectionError',
//         errorTitle: 'Selection Error',
//         errorMessage: 'An expiring contract must be selected.'
//       });
//   }
});

export default SendRemindersView;
